import * as React from "react";
import { ItemStatus } from "../entities";
import { Loading } from "./Loading";
import { Error } from "./Error";
export var StatusSize;
(function (StatusSize) {
    StatusSize[StatusSize["SMALL"] = 20] = "SMALL";
    StatusSize[StatusSize["STANDARD"] = 50] = "STANDARD";
    StatusSize[StatusSize["LARGE"] = 100] = "LARGE";
})(StatusSize || (StatusSize = {}));
export const StatusProxy = ({ status, error, minimal = false, size = StatusSize.STANDARD, children, }) => {
    switch (status) {
        case ItemStatus.ERROR:
            return React.createElement(Error, { message: error, minimal: minimal, size: size });
        case ItemStatus.READY:
            return children;
        default:
            return React.createElement(Loading, { minimal: minimal, size: size });
    }
};
//# sourceMappingURL=StatusProxy.js.map